import { useEffect, useRef } from "react";
import getPage from "../translation";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";

const getText = getPage("nav");

export default function () {
  return (
    <ul className="m-0 mx-auto py-2 container list-unstyled d-grid">
      <li>
        <NavLink to="/settings">
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
            >
              <path
                d="M18.2285 12.5C18.8253 12.5 19.3975 12.7371 19.8195 13.159C20.2415 13.581 20.4785 14.1533 20.4785 14.75V15.5C20.4785 18.4565 17.6885 21.5 12.9785 21.5C8.26852 21.5 5.47852 18.4565 5.47852 15.5V14.75C5.47852 14.1533 5.71557 13.581 6.13753 13.159C6.55948 12.7371 7.13178 12.5 7.72852 12.5H18.2285ZM18.2285 14H7.72852C7.5296 14 7.33884 14.079 7.19819 14.2197C7.05753 14.3603 6.97852 14.5511 6.97852 14.75V15.5C6.97852 17.657 9.12652 20 12.9785 20C16.8305 20 18.9785 17.657 18.9785 15.5V14.75C18.9785 14.5511 18.8995 14.3603 18.7588 14.2197C18.6182 14.079 18.4274 14 18.2285 14ZM12.9785 2.75C14.0725 2.75 15.1217 3.1846 15.8953 3.95818C16.6689 4.73177 17.1035 5.78098 17.1035 6.875C17.1035 7.96902 16.6689 9.01823 15.8953 9.79182C15.1217 10.5654 14.0725 11 12.9785 11C11.8845 11 10.8353 10.5654 10.0617 9.79182C9.28811 9.01823 8.85352 7.96902 8.85352 6.875C8.85352 5.78098 9.28811 4.73177 10.0617 3.95818C10.8353 3.1846 11.8845 2.75 12.9785 2.75ZM12.9785 4.25C12.2823 4.25 11.6146 4.52656 11.1224 5.01884C10.6301 5.51113 10.3535 6.17881 10.3535 6.875C10.3535 7.57119 10.6301 8.23887 11.1224 8.73116C11.6146 9.22344 12.2823 9.5 12.9785 9.5C13.6747 9.5 14.3424 9.22344 14.8347 8.73116C15.327 8.23887 15.6035 7.57119 15.6035 6.875C15.6035 6.17881 15.327 5.51113 14.8347 5.01884C14.3424 4.52656 13.6747 4.25 12.9785 4.25Z"
                fill="currentColor"
              />
            </svg>
          </div>
          {getText(0)}
        </NavLink>
      </li>

      <li>
        <NavLink to="/cart">
          <div className="position-relative">
            <CartBadge />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
            >
              <path
                d="M16.9785 18.5C17.5089 18.5 18.0177 18.7107 18.3927 19.0858C18.7678 19.4609 18.9785 19.9696 18.9785 20.5C18.9785 21.0304 18.7678 21.5391 18.3927 21.9142C18.0177 22.2893 17.5089 22.5 16.9785 22.5C16.4481 22.5 15.9394 22.2893 15.5643 21.9142C15.1892 21.5391 14.9785 21.0304 14.9785 20.5C14.9785 19.9696 15.1892 19.4609 15.5643 19.0858C15.9394 18.7107 16.4481 18.5 16.9785 18.5ZM16.9785 19.5C16.7133 19.5 16.4589 19.6054 16.2714 19.7929C16.0839 19.9804 15.9785 20.2348 15.9785 20.5C15.9785 20.7652 16.0839 21.0196 16.2714 21.2071C16.4589 21.3946 16.7133 21.5 16.9785 21.5C17.2437 21.5 17.4981 21.3946 17.6856 21.2071C17.8732 21.0196 17.9785 20.7652 17.9785 20.5C17.9785 20.2348 17.8732 19.9804 17.6856 19.7929C17.4981 19.6054 17.2437 19.5 16.9785 19.5ZM7.97852 18.5C8.50895 18.5 9.01766 18.7107 9.39273 19.0858C9.7678 19.4609 9.97852 19.9696 9.97852 20.5C9.97852 21.0304 9.7678 21.5391 9.39273 21.9142C9.01766 22.2893 8.50895 22.5 7.97852 22.5C7.44808 22.5 6.93937 22.2893 6.5643 21.9142C6.18923 21.5391 5.97852 21.0304 5.97852 20.5C5.97852 19.9696 6.18923 19.4609 6.5643 19.0858C6.93937 18.7107 7.44808 18.5 7.97852 18.5ZM7.97852 19.5C7.7133 19.5 7.45895 19.6054 7.27141 19.7929C7.08387 19.9804 6.97852 20.2348 6.97852 20.5C6.97852 20.7652 7.08387 21.0196 7.27141 21.2071C7.45895 21.3946 7.7133 21.5 7.97852 21.5C8.24373 21.5 8.49809 21.3946 8.68562 21.2071C8.87316 21.0196 8.97852 20.7652 8.97852 20.5C8.97852 20.2348 8.87316 19.9804 8.68562 19.7929C8.49809 19.6054 8.24373 19.5 7.97852 19.5ZM18.9785 6.5H5.24852L7.79852 12.5H15.9785C16.3085 12.5 16.5985 12.34 16.7785 12.1L19.7785 8.1C19.9085 7.93 19.9785 7.72 19.9785 7.5C19.9785 7.23478 19.8732 6.98043 19.6856 6.79289C19.4981 6.60536 19.2437 6.5 18.9785 6.5ZM15.9785 13.5H7.84852L7.07852 15.06L6.97852 15.5C6.97852 15.7652 7.08387 16.0196 7.27141 16.2071C7.45895 16.3946 7.7133 16.5 7.97852 16.5H18.9785V17.5H7.97852C7.44808 17.5 6.93937 17.2893 6.5643 16.9142C6.18923 16.5391 5.97852 16.0304 5.97852 15.5C5.97822 15.1607 6.06425 14.8269 6.22852 14.53L6.94852 13.06L3.31852 4.5H1.97852V3.5H3.97852L4.82852 5.5H18.9785C19.5089 5.5 20.0177 5.71071 20.3927 6.08579C20.7678 6.46086 20.9785 6.96957 20.9785 7.5C20.9785 8 20.8085 8.42 20.5285 8.76L17.6185 12.65C17.2585 13.16 16.6585 13.5 15.9785 13.5Z"
                fill="#707376"
              />
            </svg>
          </div>
          {getText(2)}
        </NavLink>
      </li>

      <li>
        <NavLink to="/all-products">
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
            >
              <g id="Outline / Search / Minimalistic Magnifer">
                <path
                  id="Vector"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M11.7432 3.39734C6.91067 3.39734 2.99316 7.31485 2.99316 12.1473C2.99316 16.9798 6.91067 20.8973 11.7432 20.8973C16.5757 20.8973 20.4932 16.9798 20.4932 12.1473C20.4932 7.31485 16.5757 3.39734 11.7432 3.39734ZM1.49316 12.1473C1.49316 6.48642 6.08225 1.89734 11.7432 1.89734C17.4041 1.89734 21.9932 6.48642 21.9932 12.1473C21.9932 17.8083 17.4041 22.3973 11.7432 22.3973C6.08225 22.3973 1.49316 17.8083 1.49316 12.1473ZM19.7128 20.117C20.0057 19.8241 20.4806 19.8241 20.7735 20.117L22.7735 22.117C23.0664 22.4099 23.0664 22.8848 22.7735 23.1777C22.4806 23.4706 22.0057 23.4706 21.7128 23.1777L19.7128 21.1777C19.4199 20.8848 19.4199 20.4099 19.7128 20.117Z"
                  fill="#707376"
                />
              </g>
            </svg>
          </div>
          {getText(3)}
        </NavLink>
      </li>

      <li>
        <NavLink to="/">
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
            >
              <g id="Linear / Essentional, UI / Home Angle">
                <path
                  id="Vector"
                  d="M2.60711 13.6054C2.22767 10.9683 2.03795 9.64981 2.57841 8.52247C3.11887 7.39512 4.26923 6.70986 6.56995 5.33933L7.95479 4.51439C10.0441 3.26981 11.0887 2.64752 12.243 2.64752C13.3974 2.64752 14.442 3.26981 16.5313 4.51439L17.9161 5.33933C20.2169 6.70986 21.3672 7.39512 21.9077 8.52247C22.4481 9.64981 22.2584 10.9683 21.879 13.6054L21.6002 15.5427C21.1128 18.9302 20.8691 20.6239 19.694 21.6357C18.519 22.6475 16.7957 22.6475 13.3491 22.6475H11.137C7.69041 22.6475 5.96713 22.6475 4.79207 21.6357C3.617 20.6239 3.3733 18.9302 2.88588 15.5427L2.60711 13.6054Z"
                  stroke="#707376"
                  stroke-width="1.5"
                />
                <path
                  id="Vector_2"
                  d="M15.2432 18.6473H9.24316"
                  stroke="#707376"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
              </g>
            </svg>
          </div>
          {getText(4)}
        </NavLink>
      </li>
    </ul>
  );
}

function CartBadge() {
  const Products = useSelector((e) => e.Products),
    counter = useRef();

  let itemsQuantity = 0;
  Products.cart.forEach((p) => (itemsQuantity += p.quantity));

  useEffect(
    function () {
      counter.current.classList.add("animate");
    },
    [itemsQuantity]
  );

  return (
    <span
      id="cart-counter"
      className="badge position-absolute"
      ref={counter}
      onAnimationEnd={(e) => e.target.classList.remove("animate")}
      style={{
        backgroundColor: "rgb(255, 220, 76)",
        color: "rgb(255, 255, 255)",
        top: "-3px",
        left: "-8px",
        clipPath: "circle()",
        fontSize: "11px",
      }}
    >
      {itemsQuantity}
    </span>
  );
}

{
  /* <li>
        <NavLink to="/settings/fav">
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="19"
              viewBox="0 0 22 19"
              fill="none"
            >
              <path
                d="M7.96173 16.4111L8.42605 15.8221L7.96173 16.4111ZM11 3.00088L10.4596 3.52098C10.601 3.66787 10.7961 3.75088 11 3.75088C11.2039 3.75088 11.399 3.66787 11.5404 3.52098L11 3.00088ZM14.0383 16.4111L14.5026 17.0001L14.0383 16.4111ZM8.42605 15.8221C6.91039 14.6273 5.25307 13.4605 3.93829 11.98C2.64922 10.5285 1.75 8.83474 1.75 6.63734H0.25C0.25 9.30287 1.3605 11.3363 2.81672 12.976C4.24723 14.5868 6.07077 15.8755 7.49742 17.0001L8.42605 15.8221ZM1.75 6.63734C1.75 4.48647 2.96537 2.68277 4.62436 1.92444C6.23607 1.18772 8.40166 1.38282 10.4596 3.52098L11.5404 2.48078C9.0985 -0.0562346 6.26409 -0.474369 4.00076 0.560204C1.78471 1.57317 0.25 3.92527 0.25 6.63734H1.75ZM7.49742 17.0001C8.00965 17.4039 8.55954 17.8345 9.11682 18.1602C9.67386 18.4857 10.3096 18.7502 11 18.7502V17.2502C10.6904 17.2502 10.3261 17.1295 9.87361 16.8651C9.42132 16.6008 8.95208 16.2368 8.42605 15.8221L7.49742 17.0001ZM14.5026 17.0001C15.9292 15.8755 17.7528 14.5868 19.1833 12.976C20.6395 11.3363 21.75 9.30287 21.75 6.63734H20.25C20.25 8.83474 19.3508 10.5285 18.0617 11.98C16.7469 13.4605 15.0896 14.6273 13.574 15.8221L14.5026 17.0001ZM21.75 6.63734C21.75 3.92527 20.2153 1.57317 17.9992 0.560204C15.7359 -0.474369 12.9015 -0.0562346 10.4596 2.48078L11.5404 3.52098C13.5983 1.38282 15.7639 1.18772 17.3756 1.92444C19.0346 2.68277 20.25 4.48647 20.25 6.63734H21.75ZM13.574 15.8221C13.0479 16.2368 12.5787 16.6008 12.1264 16.8651C11.6739 17.1295 11.3096 17.2502 11 17.2502V18.7502C11.6904 18.7502 12.3261 18.4857 12.8832 18.1602C13.4405 17.8345 13.9903 17.4039 14.5026 17.0001L13.574 15.8221Z"
                fill="#707376"
              />
            </svg>
          </div>
          {getText(1)}
        </NavLink>
      </li> */
}
